import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DataManagerService} from '../../data/services/DataManager/data-manager.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ManageCustomFieldsAction} from './manage-custom-fields-action';
import {AppConstants} from '../../shared/constants/app-constants';
import {CUSTOM_FIELD_TYPES} from '../../shared/constants/custom-field-types';

@Component({
    selector: 'app-invoice-custom-field-dialog',
    templateUrl: './invoice-custom-field-dialog.component.html',
    styleUrls: ['./invoice-custom-field-dialog.component.css'],
    standalone: false
})
export class InvoiceCustomFieldDialogComponent extends ManageCustomFieldsAction implements OnInit {
  topErrorMessage: string;
  keys1: string[];
  errorMsg = '';
  headerText = 'Create Custom Field';
  updateCustomFieldDetailForm: UntypedFormGroup;
  submitted = false;
  createServiceName = 'create/invoices/custom/field';
  updateServiceName = 'invoices/custom/fields';
  customFieldTypes = CUSTOM_FIELD_TYPES;
  constructor(private dialog: MatDialogRef<InvoiceCustomFieldDialogComponent>,
              dataManager: DataManagerService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private fb: UntypedFormBuilder,
              snackBar: MatSnackBar) {
    super();
    this.dataManager = dataManager;
    if (data?.editMode) {
      this.headerText = 'Edit Custom Field';
      this._updateCustomFieldUrl = AppConstants.BASE_URL + '/' + this.updateServiceName;
    } else {
      this._createCustomFieldUrl = AppConstants.BASE_URL + '/' + this.createServiceName;
    }
  }
  closeAction() {
    this.dialog.close('cancel');
  }
  get topErrorMessages(): string[] {
    if (!this.topErrorMessage) { return []; }
    if (typeof this.topErrorMessage === 'string') {
      return [this.topErrorMessage];
    }
    if (typeof this.topErrorMessage === 'object') {
      const messages: string[] = [];
      Object.values(this.topErrorMessage).forEach(value => {
        if (Array.isArray(value)) {
          messages.push(...value); // array of messages
        } else if (typeof value === 'string') {
          messages.push(value); // single string message
        }
      });
      return messages;
    }
    return [];
  }

  onSubmit() {
    this.submitted = true;
    if (!this.updateCustomFieldDetailForm) {
      return;
    }
    this.updateCustomFieldDetailForm.markAllAsTouched();
    this.updateCustomFieldDetailForm.updateValueAndValidity();

    if (this.updateCustomFieldDetailForm.invalid) {
      return;
    }
    if (this.data?.editMode) {
      this.updateCustomField();
    } else {
      this.setCustomFieldCreate();
    }
  }
  updateCustomField() {
    const patchBody = {
      id: this.data.id, // needed for update
      field_name: this.updateCustomFieldDetailForm.get('customFieldName')?.value.trim(),
      required: this.updateCustomFieldDetailForm.get('Required')?.value,
      data_type_accepted: this.updateCustomFieldDetailForm.get('datatype')?.value,
      description: this.updateCustomFieldDetailForm.get('description')?.value.trim(),
    };

    this.dataManager.patchRequest(this._updateCustomFieldUrl + '/' + this.data.id, patchBody)
      .subscribe({
        next: (res) => {
          this.dialog.close('update');
        },
        error: (err) => this.passCreateError(err.error),
      });
  }
  setCustomFieldCreate() {
    // Implement set custom field update functionality here
    console.log('Form submitted:', this.updateCustomFieldDetailForm.value);
    const patchBody = {};
    patchBody['field_name'] = this.updateCustomFieldDetailForm.get('customFieldName').value.trim();
    patchBody['required'] = this.updateCustomFieldDetailForm.get('Required').value;
    patchBody['data_type_accepted'] = this.updateCustomFieldDetailForm.get('datatype').value;
    patchBody['description'] = this.updateCustomFieldDetailForm.get('description').value.trim();
    this.createCustomField(patchBody);
  }
  save() {
    // Implement save functionality here
    this.dialog.close('save');
  }
  ngOnInit(): void {
    this.updateCustomFieldDetailForm = this.fb.group({
      customFieldName: [this.data?.field_name || '', [Validators.required, Validators.maxLength(25)]],
      Required: [this.data?.required || false, Validators.required],
      datatype: [this.data?.data_type_accepted || '', Validators.required],
      description: [this.data?.description || '', Validators.maxLength(100)],
    });
  }
  protected passCreateError(error: any) {
      this.topErrorMessage = error?.message || 'Server error. Please try again later.';
      console.error('Error creating custom field:', this.topErrorMessage);
  }

  protected passCreateResponse(res: any) {
    this.dialog.close('create');
  }
}
